<template>
  <!--
    Minimal footer. Just maintainer + source. The version badge,
    license link, and v2c-comparison blurb are gone - they made the
    page feel like a polished marketing template instead of a tool.
  -->
  <footer class="c2c-footer">
    <span class="c2c-footer-item">
      {{ t('footer.maintained_by') }}
      <a :href="maintainerUrl" target="_blank" rel="noopener noreferrer">{{ maintainerName }}</a>
    </span>
    <span class="c2c-footer-sep" aria-hidden="true">·</span>
    <a :href="repoUrl" target="_blank" rel="noopener noreferrer" class="c2c-footer-item">
      {{ t('footer.source') }}
    </a>
  </footer>
</template>

<script setup lang="ts">
import { useI18n } from "vue-i18n"
import {
  TOOL_REPO_URL, TOOL_MAINTAINER_NAME, TOOL_MAINTAINER_URL
} from "@/lib/config"

const { t } = useI18n()

const repoUrl = TOOL_REPO_URL
const maintainerName = TOOL_MAINTAINER_NAME
const maintainerUrl = TOOL_MAINTAINER_URL
</script>

<style scoped>
.c2c-footer {
  margin-top: 32px; padding: 14px 16px;
  text-align: center;
  font-size: 12px; color: #72777d;
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 8px;
  flex-wrap: wrap;
}
.c2c-footer-item { display: inline-flex; align-items: center; gap: 4px; }
.c2c-footer a { color: #3366cc; text-decoration: none; }
.c2c-footer a:hover { text-decoration: underline; }
.c2c-footer-sep { color: #c8ccd1; }
</style>
